export const BASE_CITIES_URL = "https://lkf.kazandigitalweek.com/api/geo/";
export const CITIES_URL = "cities";
export const QUERY = "q";
export const COUNTRY_ID = "country_id";
export const REGION_ID = "region_id";
